import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { PaymentOption } from './PaymentOption'

export const ListOfPaymentOptionValidation = z.object({
  list: z.instanceof(PaymentOption, { message: '[ListOfPaymentOption] list is required' }).array(),
})

export class ListOfPaymentOption extends Model {
  static create({ list }: z.infer<typeof ListOfPaymentOptionValidation>) {
    ListOfPaymentOptionValidation.parse({ list })
    return new ListOfPaymentOption(list)
  }

  static fromJSON({ json }: { json: ReturnType<ListOfPaymentOption['toJSON']> }) {
    return ListOfPaymentOption.create({
      list: json.list.map(paymentOptionJSON => PaymentOption.fromJSON({ json: paymentOptionJSON })),
    })
  }

  static empty() {
    return new ListOfPaymentOption([])
  }

  constructor(private readonly _list: PaymentOption[]) {
    super()
  }

  get list() {
    return this._list
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  isEmpty() {
    return this._list.length === 0
  }

  map<T>(callback: (paymentOption: PaymentOption) => T) {
    return this._list.map(callback)
  }
}
